import { CircularProgress } from "@mui/material";
import React from "react";
import { io } from "socket.io-client";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../../Store";
import { useBotConfigStore } from "../../../Store/Slices/ChatbotSlices/BotConfigSlice";
import { allMessagesStore } from "../../../Store/Slices/socket/AllMessagesSlice";
import {
  setSocketStatus,
  socketStatusStore
} from "../../../Store/Slices/socket/SocketSlice";
import useInternetConnection from "../../hooks/useInternetConnection";
import useUserInteraction from "../../hooks/useUserInteraction";
import { SOCKET_CONNECTION_TYPES } from "../../utils/Enum";
import AppAlert from "./AppAlert";
import AppSmallButton from "./AppSmallButton";

interface Props {
  //   timer: number;
}

const AppChatLoadingScreen: React.FC<Props> = () => {
  const dispatch = useAppDispatch();

  const { botConfig } = useAppSelector(useBotConfigStore);
  const { allMessages, liveChatConnected, sessionId } =
    useAppSelector(allMessagesStore);
  const { isOnline } = useInternetConnection();
  const { socket } = useAppSelector(socketStatusStore);
  const { userInteractionActive } = useUserInteraction({
    isEnabled: liveChatConnected ?? false,
    timeout: 900000,
    // timeout: 30000,
    resetDependency: allMessages,
  }); //default 15 minutes in milliseconds

  // ********************************************************

  // ─── CONNECTIONS EVENTS ──────────────────────────────────────────────────────────────

  // ********************************************************

  // const connectSocketEvent = () => {
  //   if (!socketRef?.current?.connected) {
  //     socketRef.current = io(SOCKET_BASE_URL, {
  //       transports: ["websocket"],
  //       reconnection: true,
  //       reconnectionDelay: 1500, // 1 second delay between reconnection attempts
  //     });
  //     socketRef.current?.on(SOCKET_CONNECTION_TYPES.CONNECT, () => {
  //       if (socketRef.current?.id && socketRef?.current?.connected) {
  //         dispatch(setSocketStatus(socketRef?.current));
  //         console.warn("socket connected again");
  //       }
  //     });
  //   }
  // };

  const disconnectSocketEvent = () => {
    if (!isOnline) return;

    socket?.disconnect();
    setTimeout(() => { socket.connect(); }, 500);
  };

  // React.useEffect(() => {
  //   if (
  //     sessionId &&
  //     allMessages?.length > 0 &&
  //     liveChatConnected &&
  //     (!socket?.connected || !socket?.id || !userInteractionActive || !isOnline)
  //   ) {
  //     // connectSocketEvent();
  //   }
  // }, [socket?.id, userInteractionActive, isOnline]); // eslint-disable-line react-hooks/exhaustive-deps

  const returnLoadingImageSpinner = () => {
    return (
      <div className="loadingContainer">
        <img
          src={botConfig.config?.company_logo?.source}
          alt={botConfig?.chatbot?.name}
          className="logoImage"
        />
        <CircularProgress size={44} className="loadingCircle" />
      </div>
    );
  };

  const returnNoInternetBox = () => {
    return (
      <AppAlert severity="error">
        Kindly check your internet connection and try again!
      </AppAlert>
    );
  };

  const returnInactivityBox = () => {
    return (
      <StyledChatLoadingScreenWrap>
        {returnLoadingImageSpinner()}
        <div className="loadingText">
          Session terminated due to low connectivity or inactivity. Click the
          button to reconnect and continue.
        </div>
        <AppSmallButton onClick={() => disconnectSocketEvent()}>
          reconnect Session
        </AppSmallButton>
      </StyledChatLoadingScreenWrap>
    );
  };

  const returnLoadingBlock = () => {
    return (
      <StyledChatLoadingScreenWrap>
        {returnLoadingImageSpinner()}
        <p className="loadingText">Loading messages...</p>
      </StyledChatLoadingScreenWrap>
    );
  };

  if (!isOnline) {
    return returnNoInternetBox();
  }

  // if (!socket?.connected || !socket?.id || !userInteractionActive || !isOnline) {
  //   return returnInactivityBox();
  // }

  // if (socket?.connected && socket?.id && allMessages?.length === 0) {
  //   return returnLoadingBlock();
  // }

  return null;
};

export default AppChatLoadingScreen;

const StyledChatLoadingScreenWrap = styled.div`
  && {
    position: absolute;
    z-index: 1;
    background-color: ${({ theme }) =>
      theme?.components?.chat_wall.background.color};
    width: 100%;
    height: 100%;
    border-radius: 12px;

    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    justify-content: center;
    align-items: center;

    .loadingContainer {
      display: flex;
      gap: 1rem;
      align-items: center;
      justify-content: center;
      position: relative;
    }

    .loadingCircle {
      position: absolute;
    }

    .logoImage {
      width: 32px;
      height: 32px;
      object-fit: cover;
      border-radius: 50%;
    }

    .loadingText {
      font-size: 15px;
      letter-spacing: 0.5px;
      font-weight: 400;
      font-family: ${({ theme }) => theme?.font?.primary.family};
      width: 80%;
      text-align: center;
    }
  }
`;
